var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-mail-magazine-check-list"},_vm._l((_vm.orderedMagazines),function(item,i){return _c('mail-magazine-check-item',{key:((item.id) + "--" + i),attrs:{"tag":"li","item":item,"change":_vm.handleChange}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }